import { useState, useEffect } from "react";

const STORAGE_KEY = "zelt-kaufen-theme";
const DEFAULT_THEME = "dark";

export function useDarkMode() {
  const [isDark, setIsDark] = useState(() => {
    if (typeof window === "undefined") return DEFAULT_THEME === "dark";

    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) return stored === "dark";
    } catch {
      // Ignore storage errors
    }

    return DEFAULT_THEME === "dark";
  });

  useEffect(() => {
    const root = document.documentElement;

    if (isDark) {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }

    try {
      localStorage.setItem(STORAGE_KEY, isDark ? "dark" : "light");
    } catch {
      // Ignore storage errors
    }
  }, [isDark]);

  const toggle = () => setIsDark(prev => !prev);

  return { isDark, toggle };
}
